let openPopupQuiclView = false;
addEventListener('pageshow', function () {
    reloadCartDraw();
})

addEventListener('load', function () {
    renderSwatchProduct();
    addEventClosePopup();
    sortPack('first');
    showPriceSale();
    renderETShipping();
      setTimeout(function () {
        renderETShipping();
    },1000);
    getMobileOperatingSystem();
    renderSizeGuild();
    checkHeightViewPort();
})
addEventListener('scroll', function () {
    checkHeightViewPort();
})
addEventListener('DOMContentLoaded', function () {
    changeQtyMiniCart();
    autoOpenMenu();
    showPriceSale();
    // Change message capcha
    if (document.querySelector('.shopify-challenge__message') != null) {
        document.querySelector('.shopify-challenge__message').textContent = customerRecaptchaMessage;
    }
    if (document.querySelector('.shopify-challenge__button') != null) {
        document.querySelector('.shopify-challenge__button').value = customerRecaptchaBtn;
    }
    renderSizeProduct();
    var timeOut = 1000;
    setTimeout(function () {
        renderSizeProduct();
        if(timeOut < 4000) {
            timeOut = timeOut + 1000
        }
    },timeOut)
})
function checkHeightViewPort() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
    }
    if (/android/i.test(userAgent)) {
        document.querySelector('body').classList.add('Operating_android');
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        document.querySelector('body').classList.add('Operating_ios');
    }
}
function autoOpenMenu() {
    let labelMenu = document.querySelectorAll('.desktop-value-label');
    let menuOpen = getCookie('menuOpen');
    if (labelMenu && menuOpen) {
        labelMenu.forEach(item => {
            if(item.innerHTML == menuOpen) {
                item.closest('details').querySelector('summary').click();
            }
        })
        eraseCookie('menuOpen');
    }
}
function sortPack(type){
    function comparator(a, b) {
        if(a.dataset.pack != undefined && b.dataset.pack != undefined) {
            if(a.dataset.pack == b.dataset.pack){
                if(a.dataset.type > b.dataset.type){
                    return -1;
                }else if(a.dataset.type < b.dataset.type){
                    return 1;
                }
                return 0;
            }
        }
        return 1;
    }

    var itemsCart = document.querySelectorAll(".cart-items .cart-items-count");
    if(itemsCart.length > 0) {
        for(let i =0; i< itemsCart.length; i++) {
            let subjectsArray = itemsCart[i].children;
            subjectsArray = Array.prototype.slice.call( subjectsArray, 0 );
            let sorted = subjectsArray.sort(comparator);
            if(type != 'first') {
                itemsCart[i].innerHTML = "";
            }
            if(sorted.length > 0) {
                for (let j= 0 ;j < sorted.length; j++) {
                    itemsCart[i].append(sorted[j])
                }
            }
        }
    }
}
function viewMoreOrViewLess(el) {
    let pack_id = el.closest('.cart-item').getAttribute('data-pack');
    el.innerHTML = el.innerHTML == cartViewmore ? cartViewless : cartViewmore;
    el.setAttribute('id', 'btn-view-more-' + pack_id)
    let cartDraw = el.closest('#CartDrawer') || el.closest('#main-cart-page');
    let itemsChild = cartDraw.querySelectorAll('.cart-item[data-pack="'+pack_id+'"][data-type="child"]');
    if(el.getAttribute('data-toggle') == "close"){
        if(cartDraw.getAttribute('id') == 'CartDrawer') {
            el.closest('.cart-item ').classList.add('!tw-mb-0')
        }
        itemsChild.forEach(child =>{
            child.classList.add('active');
        });
        if(cartDraw.querySelector(".btn-view-less-" + pack_id) == null) {
            let child = itemsChild[itemsChild.length - 1];
            let parent = child.parentNode;
            let index = Array.prototype.indexOf.call(parent.children, child);
            let btnTr = document.createElement('div');
            btnTr.className = 'button-view-less';
            btnTr.setAttribute('data-pack', pack_id);
            let btnViewLess = document.createElement('button');
            btnViewLess.className = "btn-view-less btn-view-less-" + pack_id;
            btnViewLess.setAttribute('type', 'button')
            btnViewLess.innerHTML = cartViewless;
            btnViewLess.onclick = function () {
                btnViewLess.closest('.button-view-less').classList.add('!tw-hidden')
                if(cartDraw.getAttribute('id') == 'CartDrawer') {
                    el.closest('.cart-item ').classList.remove('!tw-mb-0')
                }
                itemsChild.forEach(child =>{
                    child.classList.remove('active');
                })
                let btnViewMore = document.getElementById('btn-view-more-' + pack_id);
                btnViewMore.innerHTML = cartViewmore;
                btnViewMore.setAttribute('data-toggle', 'close');
            }
            btnTr.append(btnViewLess);
            let indexPlus = 0;
            let childNodes = cartDraw.querySelector('.cart-items-count').childNodes;
            if(childNodes.length > 0) {
                for (let i =0 ; i < childNodes.length; i++) {
                    if(typeof childNodes[i].getAttribute == "undefined" || childNodes[i].getAttribute('data-index') == null) {
                        indexPlus++;
                    }
                }
            }
            if(indexPlus > 0) {
                let countBtnViewLessAdd = cartDraw.getElementsByClassName('button-view-less').length;
                indexPlus = indexPlus - 1 - Number(countBtnViewLessAdd);
            }
            if(indexPlus == 0) {
                indexPlus = -1;
            }
            cartDraw.querySelector('.cart-items-count').insertBefore(btnTr, cartDraw.querySelector('.cart-items-count').childNodes[indexPlus + index + 2]);
            cartDraw.classList.add('!tw-mb-0')
        } else {
            let btnViewLess = cartDraw.querySelector(".btn-view-less-" + pack_id);
            btnViewLess.closest('.button-view-less').classList.remove('!tw-hidden')
            cartDraw.classList.remove('!tw-mb-0')
        }
    }else{
        if(cartDraw.getAttribute('id') == 'CartDrawer') {
            el.closest('.cart-item ').classList.remove('!tw-mb-0')
        }
        itemsChild.forEach(child =>{
            child.classList.remove('active');
        })
        let btnViewLess = cartDraw.querySelector(".btn-view-less-" + pack_id);
        btnViewLess.closest('.button-view-less').classList.add('!tw-hidden')
    }
    el.setAttribute('data-toggle',el.getAttribute('data-toggle') == "close" ? "open" : "close")
}

function formatPrice(price) {
    let decimal = price.slice(-2);
    let integer= price.slice(0, price.length - 2)
    return integer + '.' + decimal;
}

function getSectionInnerHTML(html, selector) {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
}
function calcPosition(){
    var innerHeaderwidth = document.querySelector('.headerGroup .custom-header').offsetWidth;
    var calcWidth = window.innerWidth - innerHeaderwidth ;
    document.documentElement.style.setProperty('--cartposition', `${calcWidth / 2}px`);
}
window.addEventListener("resize", (event) => { calcPosition(); });

async function addToCart(data, typeShow = 'show', el = null, openMiniCart = true, isShowNotification = true) {
  console.log('test addToCart')
    calcPosition();
    var autoCloseCart;
    let overlay = document.getElementById('overlay');
    overlay.style.display = 'block';
    let bodyData = JSON.stringify(data);
    await fetch('/cart/add.js', {
        body: bodyData,
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
    }).then(function (response) {
        return response.json();
    }).then(async function (parsedState) {
        if (parsedState.status) {
            // showNotification(parsedState.description, 'error')
          // PLANET SMART CART
          window.PlanetDataset.SmartCart.methods.openDrawer(true)
        } else {
        // PLANET SMART CART
        window.PlanetDataset.SmartCart.methods.openDrawer(true)
            parsedState.items.forEach(item => {
                setCompareAtPrice(item.variant_id, 'final_price', item.final_price)
            })
            await renderPriceShipping(false, null);
            if(typeShow == 'show') {
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');
                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                let sections = [];
                if(document.getElementById('main-cart-items')) {
                    sections.push({id: 'main-cart-items', section: document.getElementById('main-cart-items').dataset.id, selector: '.js-contents'})
                }
                if(document.getElementById('main-cart-footer')) {
                    sections.push({id: 'main-cart-footer', section: document.getElementById('main-cart-footer').dataset.id, selector: '.js-contents'})
                }
                if(document.getElementById('cart-icon-bubble')) {
                    sections.push({id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section'})
                }
                if(document.getElementById('cart-live-region-text')) {
                    sections.push({id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section'})
                }
              
                if(document.getElementById('CartDrawer')) {
                    sections.push({id: "CartDrawer", section : "cart-drawer", selector: ".drawer__inner"})
                }

                sections.forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    if(elementToReplace) {
                        elementToReplace.innerHTML =
                            getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                    }
                }));

              /**  if(openMiniCart && window.innerWidth >= 990) {
                    if (document.querySelector("cart-drawer").classList.contains('active') == false) {
                        document.querySelector("cart-drawer").classList.toggle('active')
                        autoCloseCart = setTimeout(() => {
                            document.querySelector("cart-drawer").classList.remove('active')
                        }, 4000);
                        document.querySelector("cart-drawer").addEventListener('mouseover', function () {
                            clearTimeout(autoCloseCart);
                        })
                    }
                } **/
                if(window.innerWidth < 990 && isShowNotification) {
                    showNotification('¡Artículo añadido!  <a class="tw-text-white" href="/cart">Ver carrito</a>');
                    if(document.querySelector('menu-drawer')) {
                        document.querySelector('menu-drawer').classList.add('!tw-hidden');
                        setTimeout(function () {
                            document.querySelector('menu-drawer').classList.remove('!tw-hidden');
                        },5000)
                    }
                }
                publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
            }
            changeQtyMiniCart();
        }

    }).catch(function (err) {
        console.error(err)
    }) .finally(async () => {
        if (el && window.innerWidth < 990) {
            let container = el.closest('.custom-grid-item') || el.closest('.grid__item') || el.closest('li');
            showOptionProductMobile(container)
        }
      overlay.style.display = 'none';
      await renderKlarnaservices();
        renderDataGift();
        renderETShipping();
        showPriceSale();
    });
}

async function addPackToCart(type = 'family', typeCollection = null) {
    let overlay = document.getElementById('overlay');
    overlay.style.display = 'block';
    btnAddPackToCart = document.getElementById('btn-submit-pack-to-cart');
    if (btnAddPackToCart.classList.contains('disabled')) {
        showErrorAddPackbyOpacity();
    } else {
        btnAddPackToCart.disabled = true;
        btnAddPackToCart.classList.remove('tw-cursor-pointer')
        const urlParams = new URLSearchParams(window.location.search);
        let idPackId = 'packFamilyId_' + Date.now();
        let optionPacks = document.getElementById('packs-bar_products_option');
        optionPacks = optionPacks.getElementsByClassName('product-pack-add-cart');
        let items = [];
        let packType = 'family-pack';
        if(type == 'normal') {
            idPackId = 'packId_' + Date.now();
            packType = 'child';
            packSizes = Number(urlParams.get('pack_size'));
            let configCollection = boxConfigPack[typeCollection + '-' + packSizes];
            let idProductParent = 40281292374189;
            if(configCollection) {
                let productBox = await getProductInfo(configCollection['pack_config_packaging']);
                let productParent = await getProductInfo(configCollection['pack_config_parent']);
                idProductParent = productParent.variants[0].id
                items.push({'id': productBox.variants[0].id, 'quantity': 1, 'properties': {_packId: idPackId, _packItemType: "packaging", _packSize: packSizes, _has_key: "_packId"}})
            }
            items.push({'id': idProductParent, 'quantity': 1, 'properties': {_packId: idPackId, _packItemType: "parent", _packSize: packSizes, _has_key: "_packId", _typeCollection: typeCollection}})
        } else {
            packSizes = Number(optionPacks.length);
            let productSpecial = false
            if(document.getElementById('product-family-special')) {
                productSpecial = true;
            }
            let typeCollection = 'bundle-pack';
            let packagingImg = true;
            let optionFamily = document.getElementById('option-family');
            if(optionFamily) {
                let typeType = optionFamily.querySelectorAll('.type-title');
                if (typeType[0].getAttribute('data-type') == typeType[1].getAttribute('data-type')) {
                    typeCollection = 'family-pack';
                }
            }
          let getInputPreorder = document.getElementById("CustomProductOptionProperty-Preorder");
          if(getInputPreorder){
            items.push({'id': variantsIdProductFamilyParent, 'quantity': 1, 'properties': {"preorder": "Yes", _packId: idPackId, _packItemType: "parent",_packType : 'family-pack', _has_key: "_packId",_typeCollection: typeCollection, _productSpecial: productSpecial, _packagingImg: packagingImg}});
          }else{
           items.push({'id': variantsIdProductFamilyParent, 'quantity': 1, 'properties': {_packId: idPackId, _packItemType: "parent",_packType : 'family-pack', _has_key: "_packId",_typeCollection: typeCollection, _productSpecial: productSpecial, _packagingImg: packagingImg}}); 
          }
        }

        if (optionPacks.length > 0) {
            for (let i = 0; i < optionPacks.length; i++) {
                if(optionPacks[i].querySelector('[name="properties[preorder]"]')){
                   let data = {
                    'id': optionPacks[i].querySelector('[name="properties[_idVariants]"]').value,
                    'quantity': 1,
                    'properties': {"preorder": "Yes", _packId: idPackId, _packType : packType,_packSize: packSizes, _packItemType: "child", _item: "itemPack" + i, _has_key: "_packId"},
                  };
                  items.push(data); 
                }else{
                  let data = {
                    'id': optionPacks[i].querySelector('[name="properties[_idVariants]"]').value,
                    'quantity': 1,
                    'properties': {_packId: idPackId, _packType : packType,_packSize: packSizes, _packItemType: "child", _item: "itemPack" + i, _has_key: "_packId"},
                  };
                  items.push(data);
                }
            }
        }
        items.reverse();
        await addToCart({'items': items,  'sections': ["cart-drawer", "cart-icon-bubble"],'sections_url': window.location.pathname});
        await refreshPack();
        sortPack('first');

        if(type != 'normal') {
            document.querySelector('#option-family').classList.remove('option-family-active');
            document.querySelector('.option-family__backdrop').classList.remove('option-family__backdrop--active');
            document.querySelector('.container-component-family-pack-summary').classList.add('tw-hidden');
        }

        if (document.querySelector('.packs-bar__submit')) {
            document.querySelector('.packs-bar__submit').disabled = true;
        }

    }
}

async function refreshPack() {
    let btnRemoveItemPack = document.getElementsByClassName('packs-bar__remove');
    for (let i = btnRemoveItemPack.length; i > 0; i--) {
        btnRemoveItemPack[i -1].click()
    }
}

function changeQtyMiniCart() {
    let miniCart = document.querySelector('.header__icon--cart');
    let qtyInCart = miniCart.querySelector('[aria-hidden="true"]');
    if(document.querySelector('.drawer__cart-items-wrapper') == null) {
        qtyInCart.innerHTML = '0';
        return
    }
    let cart = document.querySelector('.drawer__cart-items-wrapper').querySelector('.cart-items');
    let itemsCart = cart.querySelector('.cart-items-count');
    let totalChild = itemsCart.querySelectorAll('.cart-item[data-type="child"]').length;
    let totalPackaging = itemsCart.querySelectorAll('.cart-item[data-type="packaging"]').length;
    let qty = Number(qtyInCart.innerHTML) - Number(totalChild) - Number(totalPackaging);
    if(qty > 99) {
        qtyInCart.innerHTML = '99+';
        qtyInCart.className = 'tw-text-[0.75rem] tw-h-auto';
    } else {
        qtyInCart.innerHTML = qty;
    }
    miniCart.querySelector('.cart-count-bubble').classList.remove('!tw-hidden')
    renderPricePack();
}

function renderPricePack()  {
    let cart = document.querySelectorAll('.cart-items');
    if(cart.length > 0) {
        for(let indexCart=0 ;indexCart< cart.length; indexCart++) {
            let itemsCart = cart[indexCart].querySelector('.cart-items-count');
            let items = itemsCart.querySelectorAll('.cart-item[data-type="parent"]');
            if(items.length > 0 && typeof items != "undefined ") {
                for(let i = 0; i< items.length; i++) {
                    if (items[i].getAttribute('data-type') == 'parent') {
                        let idPack = items[i].getAttribute('data-pack');
                        if (idPack != "") {
                            let itemsChilds = itemsCart.querySelectorAll('.cart-item[data-pack="'+idPack+'"]');
                            let totalOriginalPrice = 0;
                            let totalFinalPrice = 0;
                            if(itemsChilds.length > 0) {
                                for(let j=0; j< itemsChilds.length; j++) {
                                    if(itemsChilds[j].getAttribute('data-type') == 'child') {
                                        let dataPrice = itemsChilds[j].getAttribute('data-price');
                                        dataPrice = JSON.parse(dataPrice);
                                        let originalPrice = parseFloat(dataPrice.original_price.replaceAll(',','.').replaceAll(symbol, ''));
                                        let finalPrice = parseFloat(dataPrice.final_price.replaceAll(',','.').replaceAll(symbol, ''));
                                        totalOriginalPrice = totalOriginalPrice +  originalPrice;
                                        totalFinalPrice = totalFinalPrice + finalPrice;
                                    }
                                }
                            }

                            let elOriginalPrice = document.createElement('span');
                            elOriginalPrice.className = 'original-price';
                            totalOriginalPrice = totalOriginalPrice.toFixed(2);
                            elOriginalPrice.innerHTML = convertCurrencyLocation(convertDecimalMoney(String(totalOriginalPrice)));

                            let elFinalPrice = document.createElement('span');
                            elFinalPrice.className = 'final-price';
                            totalFinalPrice = totalFinalPrice.toFixed(2);
                            elFinalPrice.innerHTML = convertCurrencyLocation(convertDecimalMoney(String(totalFinalPrice)));

                            let priceParent = items[i].querySelector('.price-pack');
                            priceParent.innerHTML = '';
                            priceParent.append(elOriginalPrice)
                            priceParent.append(elFinalPrice)
                        }
                    }
                }
            }
        }
    }
}

async function getProductInfo(handel) {
    let API_URL = '/products/' + handel + '.js';
    let res = null;
    await fetch(API_URL, {method: "GET"})
        .then(response => response.json())
        .then(function (result) {
            res = result
        })
        .catch(function (error) {});
    return res;
}

function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}

function openOrCloseItemPack() {
    let packsBarInformation = document.getElementById('packs-bar-information');

    if(packsBarInformation) {
        let translate = 0;
        packsBarInformation.classList.toggle('isHidden');
        if(packsBarInformation.classList.contains('isHidden')) {
            translate = 140;
        }
        packsBarInformation.style.transform = 'translateY(' + translate + '%)';
    }

    let el = document.getElementById('packs-bar_products_option');
    if(el) {
        el.classList.toggle('isHidden');
        el.classList.toggle('tw-h-0');
        el.classList.toggle('!tw-pt-0');
        el.classList.toggle('!tw-opacity-0');
        el.classList.toggle('isHidden');

        let translate = 200;
        if(el.classList.contains('isHidden')) {
            translate = 0;
        }
        el.style.transform = 'translateY(' + translate + '%)';
        el.classList.toggle('hidden-button');
    }
    let summary = document.getElementById('packs-bar__summary__head');
    if(summary) {
        summary.classList.toggle('!tw-hidden');
    }
    let packsBarClose = document.getElementById('packs-bar__close');
    if(packsBarClose) {
        packsBarClose.classList.toggle('!tw-hidden');
    }
}

function showErrorAddPackbyOpacity() {
    let packError  = document.getElementById('pack-bar-error');
    if(packError) {
        packError.classList.toggle('tw-opacity-0');
        packError.classList.toggle('tw-invisible');
    }
}

function Mobiletouch() {
    if (window.innerWidth < 990) {

        var productInfoWrappers = document.querySelectorAll('.product__info-wrapper.grid__item');

        productInfoWrappers.forEach(function(productInfoWrapper) {
            let colorShowMore = document.querySelector(".button-show-more-color [data-more-colors]");
            colorShowMore.addEventListener("click", colorShowMoreBtn);

            function colorShowMoreBtn() {
                productInfoWrapper.classList.add('is-active');
                productInfoWrapper.classList.add('transition');
            }
        });

        class DragProductInfo {
            constructor() {
                this.dragItem = document.querySelector('[data-product-info] .product__info-grabbing');
                this.productInfo = document.querySelector('[data-product-info]');
                this.active = false;
                this.currentY = 0;
                this.initialY = 0;
                this.yOffset = 0;
            }

            initEvents() {
                this.dragItem.addEventListener('touchstart', (event) => this.dragStart(event), false);
                this.dragItem.addEventListener('touchend', (event) => this.dragEnd(event), false);
                this.dragItem.addEventListener('touchmove', (event) => this.dragMove(event), false);

                this.dragItem.addEventListener('mousedown', (event) => this.dragStart(event), false);
                this.dragItem.addEventListener('mouseup', (event) => this.dragEnd(event), false);
                this.dragItem.addEventListener('mousemove', (event) => this.dragMove(event), false);

                document.addEventListener('gallery:swipe-end', () => {const dragProductInfo = new DragProductInfo();dragProductInfo.openInfo();}, false);}
            openInfo() {
                this.productInfo.classList.add('is-active', 'transition');
            }
            dragStart(event) {
                if (event.type === 'touchstart') {
                    this.initialY = event.touches[0].clientY;
                } else {
                    this.initialY = event.clientY;
                }

                this.active = true;
            }

            dragEnd(event) {
                this.initialY = this.currentY;
                this.active = false;

                if (this.currentY > 100) {
                    this.productInfo.classList.remove('is-active');
                } else if (this.currentY < -80) {
                    this.productInfo.classList.add('is-active');
                } else {
                    this.productInfo.classList.remove('is-active');
                }

                this.productInfo.style.transform = '';
                this.currentY = 0;
                this.setTranslate();

                this.productInfo.classList.add('transition');
                setTimeout(() => {
                    this.productInfo.classList.remove('transition');
                }, 450);
            }


            dragMove(event) {
                if (!this.active) {
                    return;
                }
                event.preventDefault();
                if (event.type === 'touchmove') {
                    this.currentY = event.touches[0].clientY - this.initialY;
                } else {
                    this.currentY = event.clientY - this.initialY;
                }
                this.yOffset = this.currentY;
                this.setTranslate();
            }

            setTranslate() {
                if (this.productInfo.classList.contains('is-active')) {
                    this.productInfo.style.transform = `translate3d(0, ${(this.currentY)}px, 0)`;
                } else {
                    this.productInfo.style.transform = `translate3d(0, ${(this.currentY)}px, 0)`;
                }
            }
        }
        const dragProductInfo = new DragProductInfo();
        dragProductInfo.initEvents();
    }
};

// Option event
function optionEvent(){
    const containerSize = document.querySelector('.custom-option-size');
    if (containerSize) {
        const buttonPopup = containerSize.querySelector('.button-popup-size');
        const buttonClosePopup = containerSize.querySelector('.close-popup-size');
        const customPopupSize = containerSize.querySelector('.custom-popup-size');
        const customOptionName = containerSize.querySelector('.custom-option-name');
        const wrapperLayout = document.querySelector('.product__info-wrapper')

        buttonPopup.addEventListener('click', function() {
            if(document.querySelector('.packs-bar') && window.innerWidth < 990 && document.querySelector('quick-add-modal[open]')) {
                document.querySelector('.packs-bar').style.display = "none";
            }
            customPopupSize.classList.toggle('active');
            containerSize.classList.toggle('active');
            wrapperLayout.classList.toggle('re-postion')
        });
        buttonClosePopup.addEventListener('click', function() {
            if(document.querySelector('.packs-bar') && window.innerWidth < 990 && document.querySelector('quick-add-modal[open]')) {
                document.querySelector('.packs-bar').style.display = "block";
            }
            customPopupSize.classList.remove('active');
            containerSize.classList.remove('active');
            wrapperLayout.classList.remove('re-postion')
        });


        if (window.screen.width >= 992) {
            customPopupSize.addEventListener('mouseleave', function() {

                customPopupSize.classList.remove('active');
                containerSize.classList.remove('active');
                wrapperLayout.classList.remove('re-postion');
            });
        }

        const optionSizeChoose = containerSize.querySelectorAll('.option-size-choose');
        optionSizeChoose.forEach(function(option) {
            if (!option.classList.contains('disabled')) {
                option.addEventListener('click', function() {
                    let optionSizeText = this.querySelector('.option-size-eachtext').textContent;
                    customOptionName.textContent = optionSizeText;
                    if(document.querySelector('.packs-bar') && window.innerWidth < 990 && document.querySelector('quick-add-modal[open]')) {
                        document.querySelector('.packs-bar').style.display = "block";
                    }
                    customPopupSize.classList.remove('active');
                    containerSize.classList.remove('active');
                    wrapperLayout.classList.remove('re-postion')
                });
            }
        });
    }
}
function OpacityOption(){
    var swatchElements = document.getElementsByClassName('swatch-selector-option');
    var swatchCount = swatchElements.length;
    var optionAppendElements = document.querySelector('.button-show-more-color');

    optionAppendElements.classList.add('!tw-opacity-0');
    optionAppendElements.classList.add('!tw-z-[-1]');
    if (swatchCount > 1) {
        optionAppendElements.classList.add('tw-flex');
        optionAppendElements.classList.remove('!tw-opacity-0');
        optionAppendElements.classList.remove('!tw-z-[-1]');
    }
}


(function (Wishlist) {
    var wishlistButton = document.querySelectorAll('.wishlist-btn');
    var wishlistTile = document.querySelectorAll('.wishlist-tile-container');
    var wishlistItemCount = document.querySelector('.wishlist-item-count');
    var wishlistHeader = document.querySelector('.header__icon--wishlist');
    var numProductTiles = wishlistTile.length;
    var wishlist = localStorage.getItem('user_wishlist') || [];
    if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
    }

    var animateWishlist = function (self) {
        self.classList.toggle('is-active');
    };

    var updateWishlist = function (self) {
        var productHandle = self.getAttribute('data-product-handle');
        var isRemove = self.classList.contains('is-active');
        if (isRemove) {
            var removeIndex = wishlist.indexOf(productHandle);
            wishlist.splice(removeIndex, 1);
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        } else {
            wishlist.push(productHandle);
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        }
        console.log(JSON.stringify(wishlist));
    };

    var activateItemsInWishlist = function () {
        wishlistButton.forEach(function (button) {
            var productHandle = button.getAttribute('data-product-handle');
            if (wishlist.indexOf(productHandle) > -1) {
                button.classList.add('is-active');
            }
        });
    };

    var displayOnlyWishlistItems = function () {
        wishlistTile.forEach(function (tile) {
            var productHandle = tile.getAttribute('data-product-handle');
            if (wishlist.indexOf(productHandle) === -1) {
                tile.parentNode.removeChild(tile);
                numProductTiles--;
            }
        });
    };

    var loadWishlist = function () {
        if (window.location.href.indexOf('wishlist') > -1) {
            displayOnlyWishlistItems();
            var wishlistLoader = document.querySelector('.wishlist-loader');
            wishlistLoader.style.display = 'none';
            var wishlistGrid = document.querySelector('.wishlist-grid');
            wishlistGrid.classList.add('is_visible');
            var wishlistHero = document.querySelector('.wishlist-hero');
            wishlistHero.classList.add('is_visible');
            var emptyList = document.querySelector('.wishlist-grid--empty-list');
            if (numProductTiles === 0) {
                emptyList.classList.add('is_visible');
            } else {
                emptyList.style.display = 'none';
            }
        }
    };

    var updateWishlistItemCount = function () {
        if (wishlistItemCount) {
            wishlistItemCount.textContent = wishlist.length;
        }
    };

    var addAnimationWishlistHeader = function () {
        wishlistHeader.classList.add('added-wishlist');
        setTimeout(() => {
            wishlistHeader.classList.remove('added-wishlist');
        }, 800)
    };

    var bindUIActions = function () {
        wishlistButton.forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                updateWishlist(this);
                animateWishlist(this);
                addAnimationWishlistHeader(this);
            });
        });
    };

    Wishlist.init = function () {
        bindUIActions();
        activateItemsInWishlist();
        loadWishlist();
        updateWishlistItemCount();
    };
})

(window.Wishlist = window.Wishlist || {});
function wishlistLoad() {
    Wishlist.init();
}
wishlistLoad();


function scrollToElement(el) {
    let parent = el.closest('section')
    scrollTo(0, parent.offsetHeight - 87)
}
function showOptionProductMobile(container) {
    let targetOverlay = container.querySelector('.overlay_index-size'),
        itemLists = container.querySelector('.index-size');
    if(targetOverlay == null) {
        let parent = container.closest('li') || container.closest('div')
        targetOverlay = parent.querySelector('.overlay_index-size');
    }
    if(itemLists) {
        itemLists.classList.toggle('show');
    }
    if (targetOverlay) {
        targetOverlay.classList.toggle('show');
    }
}

function renderSizeProduct() {
    const containerWapperCards = document.querySelectorAll('.custom-featured-product');

    containerWapperCards.forEach((container, index) => {
        var button = container.querySelector('.show-popup');
        if(button) {
            let itemLists = container.querySelector('.index-size');
            let packBar = document.querySelector('.packs-bar');
            let productItem = button.parentNode.closest('li.custom-grid-item');
            if (itemLists == null) {
                button.classList.add('btn-simple');
            } else {
                itemLists.addEventListener('mouseleave', handleMouseLeave);
                button.onclick = function () {
                    showOptionProductMobile(container);
                    productItem.classList.add('no-content-visible');
                    if(packBar && window.innerWidth < 990) {
                        packBar.style.display = "none";
                    }
                }
                let closeButton = itemLists.querySelector('.close-mobile');
                if(closeButton) {
                    closeButton.onclick = function () {
                        showOptionProductMobile(container);
                        productItem.classList.remove('no-content-visible');
                        if(packBar && window.innerWidth < 990) {
                            packBar.style.display = "block";
                        }
                    }
                }
                let inputOverLay = document.querySelector('.product-form__input-overlay')
                if(inputOverLay) {
                    inputOverLay.onclick = function () {
                        showOptionProductMobile(container)
                        productItem.classList.remove('no-content-visible');
                    }
                }
                let targetOverlay = container.querySelector('.overlay_index-size');
                if(targetOverlay) {
                    targetOverlay.onclick = function() {
                        itemLists.classList.remove('show');
                        targetOverlay.classList.remove('show');
                        productItem.classList.remove('no-content-visible');
                        if(packBar && window.innerWidth < 990) {
                            packBar.style.display = "block";
                        }
                    }
                }

                const urlParams = new URLSearchParams(window.location.search);
                if(!urlParams.get('view') === 'pack') {
                    var closeoptions = itemLists.querySelectorAll('.option-select');
                    closeoptions.forEach(function(closeoption) {
                        closeoption.addEventListener('click', function() {
                            setTimeout(function() {
                                var targetOverlayp = container.querySelector('.overlay_index-size');
                                itemLists.classList.remove('show');
                                targetOverlayp.classList.remove('show');
                                productItem.classList.remove('no-content-visible');
                            }, 0);
                        });
                    });
                }
            }
        }
    });

    // Size Guild
    const productsizeContainers = document.querySelectorAll('.product-size-guild');
    const modalSizeOutput = document.querySelector('.size-guild-modal-output');
    productsizeContainers.forEach(productsizeContainer => {
        const button = productsizeContainer.querySelector('.size-guide-button');
        button.addEventListener('click', () => {
            const modal = button.closest('.chose-option-size-guide').querySelector('.size-guide-modal');
            if (modal) {
                var clonedSectionSize = modal.cloneNode(true);
                modalSizeOutput.appendChild(clonedSectionSize);
                modalSizeOutput.querySelector('.size-guide-modal').classList.add('!tw-flex');
                button.classList.add('!tw-pointer-events-none');
                document.body.classList.add('overflow-hidden');
                const closeButton = modalSizeOutput.querySelector('.modal__header__close');
                closeButton.addEventListener('click', () => {
                    modalSizeOutputInner = modalSizeOutput.querySelector('.size-guide-modal');
                    modalSizeOutputInner.remove();
                    button.classList.remove('!tw-pointer-events-none');
                    document.body.classList.remove('overflow-hidden');
                });
                const overlayButton = modalSizeOutput.querySelector('.size-guide-modal-overlay');
                overlayButton.addEventListener('click', () => {
                    modalSizeOutputInner = modalSizeOutput.querySelector('.size-guide-modal');
                    modalSizeOutputInner.remove();
                    button.classList.remove('!tw-pointer-events-none');
                    document.body.classList.remove('overflow-hidden');
                });
            }
        });
    });
    addEventAddToCart()
}

function addEventAddToCart() {
    const urlParams = new URLSearchParams(window.location.search);
  console.log('urlParams', urlParams)
    var radioSelector = document.querySelectorAll("input[type=radio]");
    radioSelector.forEach( option => {
        if(option.getAttribute('data-type') != 'is_pack' && option.getAttribute('isFunctionAddToCart') != "true") {
            if(option.getAttribute('form')) {
                option.setAttribute('idForm', option.getAttribute('form'));
            }
            option.setAttribute('isFunctionAddToCart', "true")
            if(option.closest('variant-radios')) {
                option.closest('variant-radios').setAttribute('isFunctionAddToCart', "true")
            }
            if(!option.classList.contains('isAddEvent')) {
                option.addEventListener("click", async () => {
                        if(urlParams.get('view') !== 'pack') {
                            await inputAddToCart(option);
                        }
                });
                option.classList.add('isAddEvent')
            }

        }
    });
}
function getVariantData(el) {
    return el.variantData || JSON.parse(el.querySelector('[type="application/json"]').textContent);
}

function showNotification(message, type = 'normal', showBtnClose = true, autoHidden = true) {
    let notification = document.getElementById('notification');
    notification.querySelector('.content-notification').innerHTML = message;
    let menuDrawer = document.getElementsByTagName('menu-drawer');
    document.querySelector('body').classList.add('show-notification');
    let bg = '#373737'
    if(type == 'error') {bg = '#eb4d4b'
    } else if (type == 'success') {bg = '#DCFFF1';}
    notification.style.background = bg;

    notification.querySelector('.btn-close').style.display = 'block';
    if(!notification.classList.contains('tw-justify-between')) {
        notification.classList.add('tw-justify-between')
    }
    if(notification.classList.contains('tw-justify-center')) {
        notification.classList.remove('tw-justify-between')
    }
    if(!notification.closest('.notification').classList.contains('tw-z-[999]')) {
        notification.closest('.notification').classList.add('tw-z-[999]')
        notification.closest('.notification').classList.remove('tw-z-[5]')
    }

    let tabScrollInforProduct = document.getElementById('tab-scroll-infor-product');
    if(window.innerWidth < 990 && tabScrollInforProduct && tabScrollInforProduct.classList.contains('is-active')) {
        document.getElementsByTagName('header')[0].classList.add('!tw-hidden');
    }

    if(showBtnClose == false) {
        notification.querySelector('.btn-close').style.display = 'none';
        notification.classList.remove('tw-justify-between')
        notification.classList.add('tw-justify-center');
        notification.closest('.notification').classList.remove('tw-z-[999]')
        notification.closest('.notification').classList.add('tw-z-[5]')
    }
    notification.classList.remove('tw-hidden');
    if(menuDrawer.length > 0) {
        // menuDrawer[0].classList.add('!tw-hidden')
    }
    if(autoHidden) {
        setTimeout(function (){
            notification.classList.add('tw-hidden');
            document.querySelector('body').classList.remove('show-notification');
            let tabScrollInforProduct = document.getElementById('tab-scroll-infor-product');
            if(window.innerWidth < 990 && tabScrollInforProduct && tabScrollInforProduct.classList.contains('is-active')) {
                document.getElementsByTagName('header')[0].classList.remove('!tw-hidden');
            }
        },5000)
    }
}

function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

function renderSelectSize(formId, inputName, value, inputId, label, available, sizeLabelBefore , isPdp) {
    let idInputNew = String(inputId) + String(Math.floor(Math.random() * 1000));
    const urlParams = new URLSearchParams(window.location.search);
    let option = '';
    if(available == false) {
        option =  `<input type="radio" id="` + idInputNew +  `"
      name="` + inputName + `"
      value="` + value + `"
      form="` + formId + `"
      disabled
      class="disabled"
      >
        <label for="` + idInputNew + `" class="option-select tw-item-not-avai  !tw-text-sm !tw-font-normal !tw-not-italic !tw-leading-normal !tw-tracking-[0.6px] !tw-text-dark-grey !tw-text-left !tw-bg-[unset] !tw-m-2 !tw-p-0 !tw-border-[unset] !tw-opacity-50 !tw-line-through !tw-cursor-not-allowed" >
          <span class="!tw-mr-2">` + sizeLabelBefore + " "  + label +  `</span> 
         </label>
        `;
    } else {
        let dataType = '';
        let onClick = '';
        if(urlParams.get('view') !== 'pack') {
            onClick = 'onclick="inputAddToCart(this)"';
        }
        if(isPdp) {dataType = 'data-type="is_pdp"'}
        option = `<input type="radio"` + dataType + onClick +  ` id="` + idInputNew +  `"
      name="` + inputName + `"
      value="` + value + `"
      idForm="` + formId + `"
      >
        <label for="` + idInputNew + `" class="option-select option-size-choose !tw-text-sm !tw-font-normal !tw-not-italic !tw-leading-normal !tw-tracking-[0.6px] !tw-text-dark-grey !tw-text-left !tw-bg-[unset] !tw-m-2 !tw-p-0 !tw-border-[unset]" >
           <span class="!tw-mr-2">` + sizeLabelBefore + " " +  label +  `</span> 
            <span class="option-size-eachtext tw-hidden">` + label + `</span
          </label>
        `;
    }
    return option
};
async function inputAddToCart(option) {
  console.log('option', option)
    let formName = option.getAttribute('idForm') || option.form.attributes.id.value;
    let form = document.getElementById(formName);
    if (option.getAttribute('data-type') == 'is_pdp') {
        let btnAddToCart = document.querySelector('.product-form__submit');
        if (btnAddToCart) {
            btnAddToCart.disabled = false;
        }
    }
    let sectionParent = option.closest('section') || option.closest('product-info');
    let dataVariant = getVariantData(sectionParent);
    let newVariantValue, newProductCompareAtPrice;
    dataVariant.forEach(item => {
      console.log('dataVariant', dataVariant)
      console.log('item', item.id)
      console.log('option.value', option.getAttribute('data-variant-id'))
      const optionVariantId = option.getAttribute('data-variant-id');
      if (item.id == optionVariantId) {
            newVariantValue = item.id;
            newProductCompareAtPrice = item.compare_at_price;
      }
    });

  console.log('dataVariant', dataVariant)
  console.log('newVariantValue', newVariantValue)


    if (newVariantValue != null && newVariantValue != null) {
        if (form) {
            if (form.querySelector("[name=\"id\"]")) {
                form.querySelector("[name=\"id\"]").value = newVariantValue;
            }
            if (form.querySelector("[name=\"properties[_compareAtPrice]\"]")) {
                form.querySelector("[name=\"properties[_compareAtPrice]\"]").value = newProductCompareAtPrice;
            }
        }
    }

    if (option.name != "Color" && option.getAttribute('data-type') == null) {
        const formData = new FormData(form);
        const items = [];
        items.push({
            'id': newVariantValue,
            'quantity': 1
        });
      var preorderAttribute = {};
        if(form.elements["properties[preorder]"]){
            preorderAttribute = {
                    "preorder": "Yes"
                 };
            items[0]["properties"] = {
                "preorder": "Yes"
            }
        }
        setCompareAtPrice(newVariantValue, 'origin_price',Number(formData.get('properties[_compareAtPrice]')))
            await addToCart({
            "attributes": preorderAttribute,
            'items': items,
            'sections': ["cart-drawer", "cart-icon-bubble"]
        }, 'show', option);
    }

    let over = document.querySelectorAll('.overlay_index-size');
    let productItem = option.parentNode.closest('li.custom-grid-item');
    over.forEach(item => {
        item.classList.remove('show');
        if (productItem) {
            productItem.classList.remove('no-content-visible');
        }
    })
    let indexSize = document.querySelectorAll('.index-size')
    indexSize.forEach(item => {
        item.classList.remove('show');
        if (productItem) {
            productItem.classList.remove('no-content-visible');
        }
    })
}
function renderSwatchProduct() {
    let labelSwatch = document.querySelectorAll("label[data-swatch]");
    if(labelSwatch && labelSwatch.length > 0) {
        labelSwatch.forEach(el => {
            if(!el.classList.contains('isAddEvent')) {
                el.addEventListener("click", () => {
                    let elementSlug = el.getAttribute("data-swatch");
                    let productCard = el.parentNode.closest("section[product-slug]") || el.parentNode.closest(".product-new-custom");
                    if(elementSlug != productCard.getAttribute("product-slug")){
                        productCard.setAttribute("product-slug", elementSlug);
                        let dataProductObject;
                        var isProductPageClick = false;
                        var imageWidthParam = "";
                        if(el.classList.contains("swatch-selector-option")) {
                            dataProductObject = singleProductObj;
                            var mediaSelector = ".product__media img";
                            var isProductPageClick = true;
                            var imageWidthParam = "&width=375";
                        } else {
                            dataProductObject = productObj;
                            var mediaSelector = ".media img";
                            var imageWidthParam = "&width=550";
                        }
                        var checkNewObj = false;
                      if(!dataProductObject[elementSlug] || !dataProductObject[elementSlug].images){
                        dataProductObject = newAjaxObj;
                        checkNewObj = true;
                      }

                        if(dataProductObject[elementSlug]) {
                            let urlProduct = dataProductObject[elementSlug]['metafields']['url'];
                            productCard.querySelectorAll('a').forEach(link => {
                                if(link.href) {
                                    link.href = urlProduct;
                                }
                            })
                        }

                      var grabEl = document.getElementById("tab-scroll-infor-product");
                      if(grabEl && isProductPageClick == true){
                        grabEl.classList.add('transition');
                        setTimeout(() => {
                            grabEl.classList.remove('transition');
                        }, 450);
                        grabEl.classList.remove("is-active");
                      }

                        let imageProducts = productCard.querySelectorAll(mediaSelector) || productCard.querySelectorAll(".product__main-image img");
                        let modalZoom = document.querySelector('product-modal');
                        let imgZoom = null;
                        if(modalZoom) {
                             imgZoom = modalZoom.querySelectorAll('img');
                        }
                        imageProducts.forEach((imageProduct , index) => {
                            imageProduct.srcset = "";
                            let src = '';
                            if(isProductPageClick || checkNewObj){
                                src = "https://" + dataProductObject[elementSlug].images[index] + imageWidthParam;
                            }else{
                                src = "https://" + dataProductObject[elementSlug].resized_img;
                            }
                            imageProduct.src = src;
                            if( imgZoom && imgZoom[index]) {
                                imgZoom[index].srcset = ""
                                imgZoom[index].src = src.replaceAll("&width=375", "&width=800").replaceAll('&width=550', '&width=800')
                            }
                        });

                      
                        if(productCard.querySelector(".product__sale-label")) {
                            let label = '';
                            if(dataProductObject[elementSlug].metafields.label != 'empty') {
                                label = dataProductObject[elementSlug].metafields.label;
                                productCard.querySelector(".product__sale-label").classList.remove('!tw-hidden');
                            } else {
                                productCard.querySelector(".product__sale-label").classList.add('!tw-hidden');
                            }
                            productCard.querySelector(".product__sale-label").innerText = label;
                        }
                        if(productCard.querySelector(".product_product-url")) {
                            productCard.querySelector(".product_product-url").href = dataProductObject[elementSlug].metafields.url;
                        }
                        let newPrice = Number(dataProductObject[elementSlug].price) / 100;
                        let compareAtPrice = Number(dataProductObject[elementSlug].compare_at_price) / 100;
                        let formattedPrice = convertCurrencyLocation(convertDecimalMoney(parseFloat(newPrice).toFixed(2)));
                        let url = window.location.href;
                        if(compareAtPrice > newPrice) {
                            productCard.querySelectorAll(".product__sale-price").forEach(priceSale => {
                                priceSale.classList.remove('!tw-hidden');
                              priceSale.setAttribute("style", "padding-left: 8px;");
                                priceSale.innerText = formattedPrice;
                                priceSale.classList.add('!tw-text-[#bb0606]');
                                if(priceSale.closest('.product-price-mb')) {
                                    priceSale.closest('.product-price-mb').classList.add('price__sale');
                                }
                                
                                if(priceSale.closest('.price__sale')) {
                                    priceSale.closest('.price__sale').classList.add('!tw-flex');
                                    priceSale.closest('.price__sale').style.lineHeight = "0";
                                }
                            });
                            productCard.querySelectorAll(".price-item.price-item--regular").forEach(priceOrigin => {
                                if(url.search('product') > -1) {
                                    priceOrigin.classList.add('tab:!tw-leading-[1.54]')
                                    priceOrigin.classList.add('!tw-text-[#373737]')
                                    priceOrigin.classList.add('!tw-mr-[8px]')
                                    priceOrigin.classList.add('!tw-opacity-60')
                                }
                                priceOrigin.style.textDecoration = "line-through";
                                
                                priceOrigin.innerText = convertCurrencyLocation(convertDecimalMoney(parseFloat(compareAtPrice).toFixed(2)));
                            });
                        } else {
                           productCard.querySelectorAll(".product__sale-price").forEach(priceSale => {
                               priceSale.classList.add('!tw-hidden');
                               if(priceSale.closest('.product-price-mb')) {
                                   priceSale.closest('.product-price-mb').classList.remove('price__sale')
                               }
                               if(priceSale.closest('.price__sale')) {
                                    priceSale.closest('.price__sale').classList.remove('!tw-flex');
                                    priceSale.closest('.price__sale').style.lineHeight = "unset";
                                }
                           })
                            productCard.querySelectorAll(".price-item.price-item--regular").forEach(priceOrigin => {
                                if(url.search('product') > -1) {
                                    priceOrigin.classList.remove('tab:!tw-leading-[1.54]')
                                    priceOrigin.classList.remove('!tw-text-[#373737]')
                                    priceOrigin.classList.remove('!tw-mr-[8px]')
                                    priceOrigin.classList.remove('!tw-opacity-60')
                                }
                                
                                priceOrigin.style.textDecoration = "unset";
                                priceOrigin.innerText = formattedPrice;
                            })
                        }
                        productCard.querySelectorAll(".product__info-length").forEach(item => {
                            item.innerText = dataProductObject[elementSlug].metafields.length + "  ·  " + dataProductObject[elementSlug].metafields.color;
                        })

                        let availableGlobal = dataProductObject[elementSlug].available;
                        let notificationOutStock = productCard.querySelector('.notification-out-stock')
                        if(notificationOutStock) {
                            if(availableGlobal == true) {
                                notificationOutStock.classList.add('tw-hidden')
                            } else {
                                notificationOutStock.classList.remove('tw-hidden')
                            }
                        }

                        if(productCard.querySelector(".swatch-active")){
                            productCard.querySelector(".swatch-active").classList.remove("swatch-active");
                        }
                        el.classList.add("swatch-active");

                        // update add to cart button and product form
                        let variantsData = dataProductObject[elementSlug].variants;
                        let productForm = productCard.querySelector(".product_cart-form") || document.getElementById(formProductId);

                        productForm.querySelector("input[name='id']").value = variantsData[0].id;
                        if(productForm.querySelector("input[name='product_final_price']")) {
                            productForm.querySelector("input[name='product_final_price']").value = dataProductObject[elementSlug].price;
                        }

                        let newFormId;
                        let isPdp = false;

                        if(typeof formProductId != "undefined" && formProductId != null) {
                            if(productCard.classList.contains('product-new-custom')) {
                                isPdp = true;
                            }
                            newFormId = formProductId;
                        } else {
                            newFormId = "product-form-" + dataProductObject[elementSlug].id;
                            productForm.id = newFormId;
                        }

                        let selectSizeEl = productCard.querySelector(".product_select-size");
                        let variantRadiosEl = productCard.querySelector("variant-radios");
                        if(variantRadiosEl) {
                            variantRadiosEl.setAttribute("data-section", dataProductObject[elementSlug].id);
                            variantRadiosEl.setAttribute("data-url", dataProductObject[elementSlug].metafields.url);
                        }
                        if(selectSizeEl) {
                            selectSizeEl.innerHTML = '';
                        }

                        let optionName = dataProductObject[elementSlug].options[0];
                        for(let i=0; i<variantsData.length; ++i){
                            let tmpInputName = optionName;
                            let tmpOptionValue = variantsData[i].options[0];
                            let tmpInputId = dataProductObject[elementSlug].id + '-' + i;
                            let tmpLabel = variantsData[i].title;
                            let available = variantsData[i].available;

                            if(document.getElementById(tmpInputId)) {
                                document.getElementById(tmpInputId).remove();
                            }
                            if(document.querySelector('label[for="'+tmpInputId+'"]')) {
                                document.querySelector('label[for="'+tmpInputId+'"]').remove();
                            }

                            let tempHTML = renderSelectSize(newFormId, tmpInputName, tmpOptionValue, tmpInputId, tmpLabel, available,'Talla',isPdp);

                            selectSizeEl.insertAdjacentHTML('beforeend', tempHTML);
                        }

                        const urlParams = new URLSearchParams(window.location.search);
                        if(productCard.querySelector('.custom-option-name')){
                            productCard.querySelector('.custom-option-name').innerHTML = 'Talla';
                        }
                        if(urlParams.get('view') === 'pack') {
                            if(el.closest('quick-add-modal')) {
                                let containerSize = el.closest('product-info');
                                const customOptionName = containerSize.querySelector('.custom-option-name');
                                let customPopupSize = containerSize.querySelector('.custom-popup-size');
                                if(containerSize) {
                                    let btnAddToPack = containerSize.querySelector('.product-form__buttons').querySelector('button');
                                    btnAddToPack.disabled = true
                                    let optionSizeChoose = containerSize.querySelectorAll('.option-size-choose');
                                    optionSizeChoose.forEach(function(option) {
                                        if (!option.classList.contains('disabled')) {
                                            option.addEventListener('click', function() {
                                                let btnAddToPack = containerSize.querySelector('.product-form__buttons').querySelector('button');
                                                btnAddToPack.disabled = false
                                                let optionSizeText = this.querySelector('.option-size-eachtext').textContent;
                                                customOptionName.textContent = optionSizeText;
                                                if(document.querySelector('.packs-bar') && window.innerWidth < 990 && document.querySelector('quick-add-modal[open]')) {
                                                    document.querySelector('.packs-bar').style.display = "block";
                                                }
                                                customPopupSize.classList.remove('active');
                                                document.querySelector('.custom-option-size').classList.remove('active')
                                                containerSize.classList.remove('active');
                                                let wrapperLayout = document.querySelector('.product__info-wrapper')
                                                wrapperLayout.classList.remove('re-postion')
                                            });
                                        }
                                    });
                                }
                            }
                            if(!el.closest('quick-add-modal')) {
                                let radioSelector = productCard.querySelectorAll("input[type=radio]");
                                radioSelector.forEach( option => {
                                    option.click = null;
                                    option.addEventListener("click", async (el) => {
                                        let formName = option.getAttribute('idForm') || option.form.attributes.id.value;
                                        updateVariant(option)
                                        if(!option.closest('quick-add-modal')) {
                                            if(option.name != "Color"){
                                                beforeAddToPack(formName)
                                            }
                                        }
                                    });
                                });
                            }
                        } else {
                            if(typeof formProductId != "undefined") {
                                getVariantOption()
                                let optionSizeChoose = productCard.querySelectorAll('.option-size-choose');
                                let btnAddToCart = productCard.querySelector('.product-form__submit');
                                if(btnAddToCart) {btnAddToCart.disabled = true;}
                                optionSizeChoose.forEach(function(option) {
                                    if(!option.classList.contains('disabled')) {
                                        option.addEventListener('click', function() {
                                            let optionSizeText = option.querySelector('.option-size-eachtext').textContent;
                                            containerWrapper.querySelector('.custom-option-name').textContent = optionSizeText;
                                            containerWrapper.querySelector('.custom-popup-size').classList.remove('active');
                                            containerWrapper.querySelector('.custom-option-size').classList.remove('active');
                                        });
                                    }
                                });
                            }
                        }

                        let jsonEl = productCard.querySelector('[type="application/json"]');
                        let variantString = JSON.stringify(variantsData);
                        jsonEl.textContent = variantString;

                    }
                })
                el.classList.add('isAddEvent');
            }
        });
    }
}

function getVariantOption() {
    let containerWrapper =  document.querySelector('.product-new-custom');
    if(containerWrapper) {
        var radioSelector = containerWrapper.querySelectorAll("input[type=radio]");
        radioSelector.forEach( option => {
            if(option.getAttribute('data-type') != 'is_pack') {
                option.addEventListener("click", async () => {
                    updateVariant(option);
                });
            }
        });
    }
}

function renderMoreColorBtn(selector, insertPosition="beforeend"){
    var swatchesEl = selector.querySelector(".product_swatcher-select");
    var html = `
      <div style="border: 2px solid #b0b0b0;order: 999;" class="show-color show-more-color tab:!tw-w-[22px] tab:!tw-h-[22px] tw-w-[16px] tw-h-[16px] tab:!tw-mt-[4px] tw-mt-[2px] tw-relative tw-cursor-pointer !tw-p-0 tw-bg-white !tw-rounded-full !tw-bg-white tw-mr-[6px] tw-flex tw-justify-center tw-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          class="icon icon-plus tab:!tw-w-[14px] tw-w-[10px]"
          fill="none"
          viewBox="0 0 10 10"
        >
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
        </svg>
        
      </div>
      <div style="border: 2px solid #b0b0b0; display: none;order: 999;" class="show-color show-less-color tab:!tw-w-[22px] tab:!tw-h-[22px] tw-w-[16px] tw-h-[16px] tab:!tw-mt-[4px] tw-mt-[2px] tw-relative tw-cursor-pointer !tw-p-0 tw-bg-white !tw-rounded-full !tw-bg-white tw-mr-[6px] tw-flex tw-justify-center tw-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          class="icon icon-minus tab:!tw-w-[14px] tw-w-[10px]"
          fill="none"
          viewBox="0 0 10 2"
        >
          <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
        </svg>
        
      </div>
      `;
    swatchesEl.insertAdjacentHTML(insertPosition, html);

    var showMore = swatchesEl.querySelector(".show-more-color");
    var lessMore = swatchesEl.querySelector(".show-less-color");
    var productWrapperLi = selector.closest(".custom-grid-item") ?? selector.closest(".grid__item");
          var swatchesElNumber = swatchesEl.childElementCount;
    if(swatchesElNumber > 14){
      selector.classList.add("swatch-3-rows");
    }

    productWrapperLi.addEventListener("mouseleave", () => {
        swatchesEl.classList.add("has-many-colors");
        productWrapperLi.classList.remove("show-more-active");
        showMore.style.display = "flex";
        lessMore.style.display = "none";
    });

    showMore.addEventListener("click" , () => {
        swatchesEl.classList.remove("has-many-colors");
        productWrapperLi.classList.add("show-more-active");
        lessMore.style.display = "flex";
        showMore.style.display = "none";
    });

    lessMore.addEventListener("click" , () => {
        swatchesEl.classList.add("has-many-colors");
        productWrapperLi.classList.remove("show-more-active");
        showMore.style.display = "flex";
        lessMore.style.display = "none";
    });
}

function addEventClosePopup() {
    var overlayIndexSize = document.getElementsByClassName('.overlay_index-size'),
        indexSize = document.querySelectorAll('.index-size');
        productItem = document.querySelectorAll('li.custom-grid-item');
    if (overlayIndexSize) {
        overlayIndexSize.onclick = function(){
            indexSize.forEach((e => {
                e.classList.remove('show');
            }))
            if (productItem) {
                productItem.forEach((a => {
                    a.classList.remove('no-content-visible');
                }))
            }
            overlayIndexSize.classList.remove('show');
            let packBar = document.querySelector('.packs-bar');
            if(packBar && window.innerWidth < 990) {
                packBar.style.display = "block";
            }
        };
    }
}

function changeImgHover(el) {
    let dataSrc = el.getAttribute('data-src');
    let src = el.getAttribute('src')
    el.setAttribute('src', dataSrc);
    el.setAttribute('data-src', src);
}
function openModal(as) {
    as.querySelector('modal-opener .quick-add__submit').click();
}

function renderKlarnaservices() {
   let script = document.createElement('script');
    script.src = 'https://eu-library.klarnaservices.com/lib.js';
    script.async = true;
    script.setAttribute('data-client-id', idKlarna);
    document.head.appendChild(script);
}
function renderDataGift() {
    let componentGifts = document.querySelectorAll('.component-gif-cart');
    componentGifts.forEach(componentGift => {
        let message = componentGift.querySelector('.gift-note__message');
        let submit  = componentGift.querySelector('.gift-note__button--add');
        let remove = componentGift.querySelector('.gift-note__button--remove');
        let edit = componentGift.querySelector('.gift-note__button--edit');
        let cancel = componentGift.querySelector('.gift-note__button--cancel');
        let update = componentGift.querySelector('.gift-note__button--update');
        let counterInitial = componentGift.querySelector('.gift-note__message__counter__initial');
        let from    = message.querySelector('input[name="from-gift"]');
        let to      = message.querySelector('input[name="to-gift"]');
        let note    = message.querySelector('textarea[name="note-gift"]');
        let counter = message.querySelector('.gift-note__message__counter');
        let fromValue   = componentGift.querySelector('.gift-note__message__inner--resume__from');
        let toValue     = componentGift.querySelector('.gift-note__message__inner--resume__to');
        let noteValue   = componentGift.querySelector('.gift-note__message__inner--resume__note');

        getAttributeData(message, from, to, note, counter, fromValue, toValue, noteValue, submit, counterInitial, edit, remove, cancel, update);
    })
}

async function getAttributeData(message, from, to, note, counter, fromValue, toValue, noteValue, submit, counterInitial, edit, remove, cancel, update){
    await fetch("/cart.js").then(result => result.json()).then(result => {
        if(JSON.stringify(result.attributes) !='{}' && result.attributes["gift-from"] && result.attributes["gift-to"] && result.attributes["gift-note"]){
            message.classList.add("is-visible");
            hiddenOrShowInput('none', from, to, note, counter, fromValue, toValue, noteValue)
            editBtn("inline-block", edit, remove);
            updateBtn("none", cancel, update);
            submit.style.display = "none";
            if(result.attributes["gift-from"] && result.attributes["gift-to"] && result.attributes["gift-note"]){
             from.value = result.attributes["gift-from"].split(": ")[1] ?? "";
              to.value   = result.attributes["gift-to"].split(": ")[1] ?? "";
              note.value = result.attributes["gift-note"] ?? ""; 
            }

            fromValue.innerText = from.value;
            toValue.innerText = to.value;
            noteValue.innerText = note.value;

            counterInitial.innerText = note.value.length + " /";
        }else{
            hiddenOrShowInput('block', from, to, note, counter, fromValue, toValue, noteValue)
            editBtn("none", edit, remove);
            updateBtn("none", cancel, update);
            submit.style.display = "inline-block";
        }
    });
}

function hiddenOrShowInput(type, from, to, note, counter, fromValue, toValue, noteValue) {
    from.style.display = type;
    to.style.display = type;
    note.style.display = type;
    counter.style.display = type;

    let type1 = 'none';
    if(type == 'none') {type1 = 'block'}
    fromValue.style.display = type1;
    toValue.style.display = type1;
    noteValue.style.display = type1;
}

function updateBtn(type="inline-block", cancel, update){
    cancel.style.display = type;
    update.style.display = type;
}

function editBtn(type="inline-block", edit, remove){
    edit.style.display = type;
    remove.style.display = type;
}

async function renderPriceShipping(isUpdateNavbar = false, newPrice = null) {
    if(newPrice == null) {
        await fetch('/cart.json', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => response.json()).then(function (data) {
            newPrice = parseFloat( data.items_subtotal_price) / 100;
        })
    }
console.log('defaultCountry', defaultCountry)
    await fetch('/cart/prepare_shipping_rates.json', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            shipping_address: {
                country: defaultCountry,
                zip: defaultZip,
                province: defaultProvince
            }
        })
    }).then(response => response.json()).then(function () {
        fetch('/cart/async_shipping_rates.json').then(response => response.json()).then(data => {
            if (data == null || data.error) {return}

            let shippingRatePrice = Number(data.shipping_rates[0].price);


            let cartPage = document.getElementById('main-cart-page');
            if(cartPage && isUpdateNavbar) {
                let underFreeShippingEl = cartPage.querySelector(".cart-under-freeshiping");
                let higherFreeShippingEl = cartPage.querySelector(".cart-higher-freeshiping");
                let underFreeShippingTextEl = cartPage.querySelector(".cart-under-freeshiping_text").querySelector('.price-freeShip');
                let cartProgressBarEls = cartPage.querySelectorAll(".cart-dropdown__progress__bar__inner");
                let isFreeShipping = true;
                if(shippingRatePrice > 0) {
                    isFreeShipping = false;
                    underFreeShippingEl.style.display = "flex";
                    higherFreeShippingEl.style.display = "none";
                    let newRemainMoney = convertCurrencyLocation(convertDecimalMoney(parseFloat((FREE_SHIPPING_PRICE - newPrice)).toFixed(2)));
                    underFreeShippingTextEl.innerText = newRemainMoney;
                    cartProgressBarEls.forEach(el => {
                        el.style.width = ((newPrice / FREE_SHIPPING_PRICE) * 100) + "%";
                    });
                }
                if(isFreeShipping){
                    underFreeShippingEl.style.display = "none";
                    higherFreeShippingEl.style.display = "block";
                }
            }

            let sectionCartContains = document.querySelectorAll(".section-cart-info");

            sectionCartContains.forEach(sectionCartContain => {
                let totalPriceElements = sectionCartContain.querySelectorAll(".footer-totals__subtotal-value");
                let totalPriceMobileElement = sectionCartContain.querySelector(".totals__subtotal-value-mobile");
                let footerShippingPriceEl = sectionCartContain.querySelector(".footer_shipping-price");
                let priceShipping = convertCurrencyLocation(convertDecimalMoney(parseFloat(shippingRatePrice).toFixed(2)));
                if(shippingRatePrice > 0) {
                    priceShipping = convertCurrencyLocation(convertDecimalMoney(shippingRatePrice));
                    let finalPrice = newPrice + Number(shippingRatePrice);
                    totalPriceElements.forEach(totalPriceElement => {
                        totalPriceElement.innerText = convertCurrencyLocation(convertDecimalMoney(parseFloat(finalPrice).toFixed(2)));
                        totalPriceMobileElement.innerText = totalPriceElement.innerText;
                    });
                }
                footerShippingPriceEl.innerText = priceShipping
            });
        }).finally(function () {
            let loadding = document.getElementById('loadding-price-cart');
            if(loadding) {
                loadding.classList.add('tw-hidden');
            }
        });
    });
}

async function updateJson(data) {
    await fetch('/cart/update.json', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
    }).then(response => response.json()).then(json => {});
}

function openGiftComponent(el) {
    let componentGift = el.closest('.component-gif-cart');
    let message = componentGift.querySelector('.gift-note__message');
    let giftWrapper = componentGift.querySelector(".gift-note");
    message.classList.toggle('is-visible');
    giftWrapper.classList.toggle("is-open");
}
function disableButtonIfNeeded(button, from, to, note) {
    if (from.value && to.value && note.value) {
        button.removeAttribute('disabled');
    } else {
        button.setAttribute('disabled', 'disabled');
    }
}

async function submitGiftComponent(el, errMsg='') {
    let componentGift = el.closest('.component-gif-cart');
    let message = componentGift.querySelector('.gift-note__message');
    let error   = message.querySelector('.gift-note__message__errors');
    let from    = message.querySelector('input[name="from-gift"]');
    let to      = message.querySelector('input[name="to-gift"]');
    let note    = message.querySelector('textarea[name="note-gift"]');
    let button = componentGift.querySelector('.gift-note__button');

    disableButtonIfNeeded(button, from, to, note);

    from.addEventListener('input', () => disableButtonIfNeeded(button, from, to, note));
    to.addEventListener('input', () => disableButtonIfNeeded(button, from, to, note));
    note.addEventListener('input', () => disableButtonIfNeeded(button, from, to, note));

    if(from.checkValidity() && to.checkValidity() && note.checkValidity()) {
        let dataParent = {'id': giftVariantId, 'quantity': 1,'properties': {_itemType : 'gift'}};
        let sections = ['cart-live-region-text',"cart-drawer", "cart-icon-bubble"];
        if(document.getElementById('main-cart-items')) {
            sections.push(document.getElementById('main-cart-items').dataset.id)
        }
        if(document.getElementById('main-cart-footer')) {
            sections.push(document.getElementById('main-cart-footer').dataset.id)
        }

        await addToCart({'items': [dataParent], 'sections': sections,'sections_url': window.location.pathname}, 'show' , null, false, false);

        let overlay = document.getElementById('overlay');
        overlay.style.display = 'block';

        await refreshPack();
        sortPack('last');

        let data = {"attributes":{"gift-from":"From: " + from.value, "gift-to":"To: " + to.value, "gift-note": note.value}}
        await updateJson(data);
        updateValueForm(from.value, to.value, note.value)
        changeFormGiftComponent('none',note.value, from.value, to.value);

        let componentGifts = document.querySelectorAll('.component-gif-cart');
        componentGifts.forEach(componentGift => {
            let message = componentGift.querySelector('.gift-note__message');
            let giftWrapper = componentGift.querySelector(".gift-note");
            if(!message.classList.contains('is-visible')) {message.classList.add('is-visible');}
            if(!giftWrapper.classList.contains('is-open')) {giftWrapper.classList.add('is-open');}
        });

        overlay.style.display = 'none';
    } else {
        error.style.display = "block";
        error.innerHTML = errMsg;
    }
}
function changeFormGiftComponent(type, noteValue, formValue = "", toValue = "") {
    let componentGifts = document.querySelectorAll('.component-gif-cart');
    componentGifts.forEach(componentGift => {
        let submit  = componentGift.querySelector('.gift-note__button--add');
        let remove = componentGift.querySelector('.gift-note__button--remove');
        let edit = componentGift.querySelector('.gift-note__button--edit');
        let cancel = componentGift.querySelector('.gift-note__button--cancel');
        let update = componentGift.querySelector('.gift-note__button--update');
        let message = componentGift.querySelector('.gift-note__message');
        let counterInitial = componentGift.querySelector('.gift-note__message__counter__initial');

        let counter = message.querySelector('.gift-note__message__counter');
        let error   = message.querySelector('.gift-note__message__errors');
        let from    = message.querySelector('input[name="from-gift"]');
        let to      = message.querySelector('input[name="to-gift"]');
        let note    = message.querySelector('textarea[name="note-gift"]');

        let fromValueGift   = componentGift.querySelector('.gift-note__message__inner--resume__from');
        let toValueGift     = componentGift.querySelector('.gift-note__message__inner--resume__to');
        let noteValueGift   = componentGift.querySelector('.gift-note__message__inner--resume__note');

        fromValueGift.textContent = formValue;
        toValueGift.textContent   = toValue;
        noteValueGift.textContent = noteValue;

        hiddenOrShowInput(type, from, to, note, counter, fromValueGift, toValueGift, noteValueGift)
        updateBtn('none', cancel, update);

        if(type == 'block') {
            submit.style.display = "inline-block";
            editBtn("none", edit, remove);
            counterInitial.innerText = note.value.length + " /";
        } else {
            submit.style.display = type;
            error.style.display = type;
            editBtn("inline-block", edit, remove);
        }
    });
}

async function removeGiftComponent(el) {
    let componentGift = el.closest('.component-gif-cart');
    let message = componentGift.querySelector('.gift-note__message');
    let note    = message.querySelector('textarea[name="note-gift"]');
    let overlay = document.getElementById('overlay');
    overlay.style.display = 'block';

    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    let item = document.querySelector('[data-item-type="gift"]');
    var promise = new Promise(resolve => {
        if(item && cartItems) {
            let indexItem = item.getAttribute('data-index');
            cartItems.updateQuantity(indexItem, 0).then(() => {
                resolve();
            });
        } else {
            resolve();
        }
    })
    promise.then(() => {
        renderPriceShipping();
        renderKlarnaservices();
        updateValueForm()
        let miniCart = document.querySelector('.header__icon--cart');
        sortPack('first');
        changeFormGiftComponent('block', note.value)
        overlay.style.display = 'none';
    })
}

function cancelGiftComponent(el) {
    let componentGift = el.closest('.component-gif-cart');
    let message = componentGift.querySelector('.gift-note__message');
    let submit  = componentGift.querySelector('.gift-note__button--add');
    let remove = componentGift.querySelector('.gift-note__button--remove');
    let edit = componentGift.querySelector('.gift-note__button--edit');
    let cancel = componentGift.querySelector('.gift-note__button--cancel');
    let update = componentGift.querySelector('.gift-note__button--update');

    let from    = message.querySelector('input[name="from-gift"]');
    let to      = message.querySelector('input[name="to-gift"]');
    let note    = message.querySelector('textarea[name="note-gift"]');
    let counter = message.querySelector('.gift-note__message__counter');
    let error   = message.querySelector('.gift-note__message__errors');

    let fromValue   = componentGift.querySelector('.gift-note__message__inner--resume__from');
    let toValue     = componentGift.querySelector('.gift-note__message__inner--resume__to');
    let noteValue   = componentGift.querySelector('.gift-note__message__inner--resume__note');

    if(from.value == "") from.value = fromValue.innerText;
    if(to.value == "") to.value = toValue.innerText;
    if(note.value == "") note.value = noteValue.innerText;
    updateErrMsgWhenTyping(error);
    hiddenOrShowInput('none', from, to, note, counter, fromValue, toValue, noteValue)
    editBtn("inline-block", edit, remove);
    updateBtn("none", cancel, update);
    submit.style.display = "none";
}

function editGiftComponent(el) {
    let componentGift = el.closest('.component-gif-cart');
    let message = componentGift.querySelector('.gift-note__message');
    let submit  = componentGift.querySelector('.gift-note__button--add');
    let remove = componentGift.querySelector('.gift-note__button--remove');
    let edit = componentGift.querySelector('.gift-note__button--edit');
    let cancel = componentGift.querySelector('.gift-note__button--cancel');
    let update = componentGift.querySelector('.gift-note__button--update');

    let from    = message.querySelector('input[name="from-gift"]');
    let to      = message.querySelector('input[name="to-gift"]');
    let note    = message.querySelector('textarea[name="note-gift"]');
    let counter = message.querySelector('.gift-note__message__counter');

    let fromValue   = componentGift.querySelector('.gift-note__message__inner--resume__from');
    let toValue     = componentGift.querySelector('.gift-note__message__inner--resume__to');
    let noteValue   = componentGift.querySelector('.gift-note__message__inner--resume__note');

    hiddenOrShowInput('block', from, to, note, counter, fromValue, toValue, noteValue)
    editBtn("none", edit, remove);
    updateBtn("inline-block", cancel, update);
    submit.style.display = "none";
}

function checkNoteGift(el) {
    let componentGift = el.closest('.component-gif-cart');
    let counterInitial = componentGift.querySelector('.gift-note__message__counter__initial');
    let message = componentGift.querySelector('.gift-note__message');
    let error   = message.querySelector('.gift-note__message__errors');

    counterInitial.innerText = el.value.length + " /";
    updateErrMsgWhenTyping(error)
}

function updateErrMsgWhenTyping(error){
    if(error.style.display = "block"){
        error.style.display = "none";
    }
}

function updateValueForm(formValue = "", toValue = "", noteValue = "") {
    let componentGifts = document.querySelectorAll('.component-gif-cart');
    componentGifts.forEach(componentGift => {
        let message = componentGift.querySelector('.gift-note__message');
        message.querySelector('input[name="from-gift"]').value = formValue;
        message.querySelector('input[name="to-gift"]').value = toValue;
        message.querySelector('textarea[name="note-gift"]').value = noteValue;
    })
}

function updateGiftComponent(el) {
    let componentGift = el.closest('.component-gif-cart');
    let message = componentGift.querySelector('.gift-note__message');
    let error   = message.querySelector('.gift-note__message__errors');
    let from    = message.querySelector('input[name="from-gift"]');
    let to      = message.querySelector('input[name="to-gift"]');
    let note    = message.querySelector('textarea[name="note-gift"]');
    let originalNoteValue = note.value;

    let button = componentGift.querySelector('.gift-note__button.gift-note__button--update');
    disableButtonIfNeeded(button, from, to, note, originalNoteValue);
    note.addEventListener('input', () => disableButtonIfNeeded(button, from, to, note, originalNoteValue));

    if(from.checkValidity() && to.checkValidity() && note.checkValidity()) {
        let componentGifts = document.querySelectorAll('.component-gif-cart');
        componentGifts.forEach(componentGift => {
            let message = componentGift.querySelector('.gift-note__message');
            let submit  = componentGift.querySelector('.gift-note__button--add');
            let remove = componentGift.querySelector('.gift-note__button--remove');
            let edit = componentGift.querySelector('.gift-note__button--edit');
            let cancel = componentGift.querySelector('.gift-note__button--cancel');
            let update = componentGift.querySelector('.gift-note__button--update');
            let counter = message.querySelector('.gift-note__message__counter');
            let fromValue   = componentGift.querySelector('.gift-note__message__inner--resume__from');
            let toValue   = componentGift.querySelector('.gift-note__message__inner--resume__to');
            let noteValue   = componentGift.querySelector('.gift-note__message__inner--resume__note');

            fromValue.textContent = from.value;
            toValue.textContent   = to.value;
            noteValue.textContent = note.value;

            updateValueForm(from.value, to.value, note.value)
            hiddenOrShowInput('none', message.querySelector('input[name="from-gift"]'), message.querySelector('input[name="to-gift"]'), message.querySelector('textarea[name="note-gift"]'), counter, fromValue, toValue, noteValue)
            editBtn("inline-block", edit, remove);
            updateBtn('none', cancel, update);
            submit.style.display = "none";
        })

        error.style.display = "none";
    }else{
        error.style.display = "block";
        error.innerHTML = "Debes rellenar todos los campos";
    }
}

function updateVariant(option) {
    let formName = option.getAttribute('idForm') || option.form.attributes.id.value;
    let form = document.getElementById(formName);
    let btnAddToCart = form.querySelector('.product-form__submit');
    if(btnAddToCart) {
        btnAddToCart.disabled = false;
    }
    let sectionParent = option.closest('product-info') || option.closest('.grid__item') || option.closest('.product-tile');
    let dataVariant = getVariantData(sectionParent);
    let newVariantValue, newProductCompareAtPrice, price;
    dataVariant.forEach(item => {
    const optionVariantId = option.getAttribute('data-variant-id');
      if (item.id == optionVariantId) {
        // if(item.title == option.value) {
            newVariantValue = item.id;
            newProductCompareAtPrice = item.compare_at_price;
            price = item.price;
        }
    });

    if(form) {
        if(form.querySelector("[name=\"product_final_price\"]") && price) {
            form.querySelector("[name=\"product_final_price\"]").value = price;
        }
        if(form.querySelector("[name=\"id\"]") && newVariantValue) {
            form.querySelector("[name=\"id\"]").value = newVariantValue;
        }
        if(form.querySelector("[name=\"properties[_compareAtPrice]\"]") && newProductCompareAtPrice) {
            form.querySelector("[name=\"properties[_compareAtPrice]\"]").value = newProductCompareAtPrice;
        }
    }
}

function openPopUpOutOfStock(el)
{
    let productSizeGuild = el.parentNode.querySelector('.option-select') || el.parentNode.querySelector('.option-size-choose');
    let option = document.getElementById(productSizeGuild.getAttribute('for'))
    updateVariant(option);
    let formName = option.getAttribute('idForm') || option.form.attributes.id.value;
    let form = document.getElementById(formName);
    let variantId  = form.querySelector("[name=\"id\"]").value;
    let modal = document.getElementById('send-out-of-stock');
    if(modal) {
        modal.querySelector('#variant_id').value = variantId;
        modal.classList.remove('tw-hidden')
    }
}
function addDivisorCharacter(number){
    let format = new Intl.NumberFormat({
        style: 'currency'
    });
    return format.format(number);
}
function addToClipboard() {
    var currentURL = window.location.href;

    navigator.clipboard.writeText(currentURL)
        .catch(error => {
            console.error('Error copying URL to clipboard:', error);
            alert("Failed to copy URL to clipboard");
        });
    showNotification('¡Se ha copiado la url, pegala donde te quieras!')
}

function renderETShipping() {
    let deliveryEstimates = JSON.parse(getCookie('deliveryEstimates'));
    if(deliveryEstimates == null) {
        document.querySelector('estimated-delivery').renderET();
    }
    deliveryEstimates = JSON.parse(getCookie('deliveryEstimates'))
    let cartEstimateShippings = document.querySelectorAll('.cart-estimate-shipping');
    cartEstimateShippings.forEach(cartEstimateShipping=> {
        let deliveryMethod = cartEstimateShipping.querySelector('.delivery_method');
        deliveryMethod.innerHTML = '';
    })
    if(deliveryEstimates) {
        deliveryEstimates.forEach(deliveryEstimate => {
            let cartEstimateShippings = document.querySelectorAll('.cart-estimate-shipping');
            cartEstimateShippings.forEach(cartEstimateShipping=> {
                let deliveryMethod = cartEstimateShipping.querySelector('.delivery_method');
                let div = document.createElement('div')
                div.className = 'shipping-date_standard tw-inline-block tw-text-emerald tw-text-[14px] tw-leading-[22px] tw-tracking-[0.8px]';
                div.innerHTML = estimatedDeliveryMess.replace('{{ delivery_date }}', deliveryEstimate.deliveryDate) + ' ';
                let span = document.createElement('span');
                span.className = 'tw-text-text-grey tw-text-emerald tw-text-[14px] tw-leading-[22px] tw-tracking-[0.8px]';
                span.innerHTML = estimatedDeliveryWithMess.replace('{{ method_name }}', deliveryEstimate.deliveryMethod);
                div.appendChild(span);
                deliveryMethod.append(div);
                cartEstimateShipping.classList.remove('tw-hidden');
            })
        })
    }
}
let pageNext = 2;
async function getProductNextPage(nextUrl) {
    let res = await fetch(nextUrl);
    return await res.text();
}
async function lazyLoadProducts(totalPage, parent) {
    if(pageNext <= Number(totalPage)) {
        let nextUrl = new URL(window.location.href);
        nextUrl.searchParams.append('page', pageNext);
        pageNext++;
        let nextPage = await getProductNextPage(nextUrl.href);
        const parser = new DOMParser();
        const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

        const productGrid = nextPageDoc.getElementById('product-grid');
        const new_products = productGrid.getElementsByClassName('grid__item');
        for (let i = 0; i < new_products.length; i++) {
            new_products[i].querySelectorAll('input[type=radio]').forEach(item => {
                item.classList.add('notEvent')
            })
            let single_product = new_products[i].cloneNode(true);
            parent.appendChild(single_product);
        }
        var scriptsInsideFetch = nextPageDoc.querySelectorAll("script[data-script='render-color']");
        if(scriptsInsideFetch){
            scriptsInsideFetch.forEach(script => {
                eval(script.innerHTML);
            });
        }
        renderSwatchProduct();
      renderSizeGuild();
        renderSizeProduct();
        addEventClosePopup();
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('view') === 'pack') {
            var radioSelector = document.querySelectorAll(".notEvent");
            radioSelector.forEach( option => {
                option.addEventListener("click", async () => {
                    updateVariant(option)
                    var formName = option.getAttribute('idForm') || option.form.attributes.id.value;
                    if(option.name != "Color"){
                        beforeAddToPack(formName)
                    }
                });
                option.classList.remove('notEvent');
            });
        }
    } else {
        if(document.getElementById('anchor')) {
            document.getElementById('anchor').remove();
        }
    }
}
function isInViewport(element, firstBottom = 0, firstTop = 0) {
    if(element) {
        const rect = element.getBoundingClientRect();
        return (
            (rect.top + firstTop) >= 0 &&
            rect.left >= 0 &&
            (rect.bottom - firstBottom) <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    return false
}
function convertDecimalMoney(number) {
    number = String(number)
    if(settingDecimalMoney == 'comma') {
        return number.replaceAll('.', ',');
    }
    return number.replaceAll(',', '.');
}

function convertCurrencyLocation(currency) {
    switch (settingCurrencyLocation) {
        case 'before':
            return symbol + currency;
        case 'before_space':
            return symbol + ' ' + currency;
        case 'after':
            return currency + symbol;
        case 'after_space':
            return currency + ' ' + symbol;
    }
}

function setCompareAtPrice (variationID,type,price) {
    let dataVariation = JSON.parse(getCookie('dataVariation'));
    if(dataVariation == null) {
        dataVariation = {};
    }
    let objectNew = {};
    if(type == 'origin_price') {
        objectNew = {origin_price : price};
    } else {
        objectNew = {final_price : price};
    }
    if(dataVariation[variationID]) {
        let objectOld = dataVariation[variationID];
        objectNew = {...objectOld, ...objectNew};
    }
    dataVariation[variationID] = objectNew;
    setCookie('dataVariation',JSON.stringify(dataVariation))
}

function showPriceSale() {
    let dataVariation = JSON.parse(getCookie('dataVariation'));
    if(dataVariation) {
        for (const [key, value] of Object.entries(dataVariation)) {
            let originPrice = value.origin_price;
            let finalPrice = value.final_price;
            if(originPrice > finalPrice) {
                document.querySelectorAll('.price-item-' + key).forEach(el => {
                    let qty = el.closest('.cart-item').querySelector('.quantity__input').value;
                    let originPriceNew = parseFloat(originPrice) * Number(qty)
                    el.querySelector('.price--end').classList.add('final-price');
                    el.querySelector('.original-price').innerHTML =  convertCurrencyLocation(convertDecimalMoney(addDivisorCharacter(parseFloat(originPriceNew) / 100 )))
                })
            }
        }
    }
}

function preloadImage(){
    let preloadImgEl = document.getElementById("preload-img");
  preloadImgEl.innerHTML = "";
    if(productObj){
      Object.keys(productObj).forEach(function(key) {
        var tempImgEl = document.createElement("img");
        tempImgEl.src = "https://" + productObj[key].images[0] + "&width=550";
        preloadImgEl.appendChild(tempImgEl);
      });
      }
}

function preloadnew(url){
//     fetch("https://gl.jimmylion.com/collections/men-socks-mid-calf",{
//     method: 'GET',
//     credentials: 'include',
//     mode: 'no-cors',
// }).then(()=>{console.log("loaded")})
    const p = new Promise((resolve,reject)=>{
        var preloadLink = document.createElement("link");
          preloadLink.href = url;
          preloadLink.rel = "preload";
          preloadLink.as = "fetch";
            preloadLink.onload = () => resolve();
            preloadLink.onerror = () => reject();
          document.head.appendChild(preloadLink);
  
    });
    return p;
}

function setWithExpiry(key, value, ttl) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

function renderSizeGuild(){
    let productCard = document.querySelectorAll("section[product-slug-old]");
    if(productCard){
        productCard.forEach(product => {
            if(!product.getAttribute("event-size-guild")){
                let addBtn = product.querySelector(".product-form__submit");
                let productSizeGuildHandle = product.getAttribute("sizeguild-handle");
                let checkLoaded = product.getAttribute("loaded-sizeguild");
                product.setAttribute("event-size-guild", "true");
                if(addBtn && productSizeGuildHandle && !checkLoaded){
                    addBtn.addEventListener("click", () => {
                        let localStorageKey = "sizeguild_" + productSizeGuildHandle;
                        let productHandle = product.getAttribute("product-slug-old");
                        let preloadUrl = "/products/" + productHandle + "?view=sizeguide";
                        let sizeGuildWrapper = product.querySelector(".chose-option-size-guide");
                        var sizeGuildModalHtml = "";
               
                        let localStorageData = getWithExpiry(localStorageKey);
                
                        if(localStorageData && (typeof localStorageData !== "undefined") && (localStorageData != "{}")){
                            // let parser = new DOMParser();
                            // sizeGuildModalHtml = parser.parseFromString(localStorageData, "text/html");
                            if (sizeGuildWrapper.querySelector('.size-guide-modal')) {
                                sizeGuildWrapper.querySelector('.size-guide-modal').remove();          
                            }
                            sizeGuildWrapper.insertAdjacentHTML("afterbegin", localStorageData);
                        }else{
                            preloadnew(preloadUrl).finally(() => {
                                   
                            });
                            fetch(preloadUrl,{
                                method: 'GET',
                                credentials: 'include',
                                mode: 'no-cors',
                                }).then(response=> response.text()).then(data => {
                                    let parser = new DOMParser();
                                    let htmlDocument = parser.parseFromString(data, "text/html");
                                    var sizeGuildModalHtml = htmlDocument.querySelector(".size-guide-modal");
                                    product.setAttribute("loaded-sizeguild", "true");
                                    let sizeGuildHandle = sizeGuildModalHtml.getAttribute("sizeguild-handle");
                                    if (sizeGuildWrapper.querySelector('.size-guide-modal')) {
                                        sizeGuildWrapper.querySelector('.size-guide-modal').remove();          
                                    }
                                    sizeGuildWrapper.appendChild(sizeGuildModalHtml);
                                    if(sizeGuildHandle != ""){
                                        let key = "sizeguild_" + sizeGuildHandle;
                                        setWithExpiry(key, sizeGuildModalHtml.outerHTML, 86400);
                                    }
                                });
                        }
                    });
                }
            }
        });
    }
}
function reloadCartDraw() {
    let sections = [ 'cart-icon-bubble', 'cart-live-region-text', "cart-drawer", "cart-icon-bubble"];
    let body = JSON.stringify({
        sections: sections,
        sections_url: window.location.pathname
    });
    fetch('/cart/update', { ...fetchConfig(), ...{ body } }) .then((response) => {
        return response.text();
    })
    .then(async (state) => {
        let parsedState = JSON.parse(state);

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        let sections = [];
        if(document.getElementById('main-cart-items')) {
            sections.push({id: 'main-cart-items', section: document.getElementById('main-cart-items').dataset.id, selector: '.js-contents'})
        }
        if(document.getElementById('main-cart-footer')) {
            sections.push({id: 'main-cart-footer', section: document.getElementById('main-cart-footer').dataset.id, selector: '.js-contents'})
        }
        if(document.getElementById('cart-icon-bubble')) {
            sections.push({id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section'})
        }
        if(document.getElementById('cart-live-region-text')) {
            sections.push({id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section'})
        }
        if(document.getElementById('CartDrawer')) {
            sections.push({id: "CartDrawer", section : "cart-drawer", selector: ".drawer__inner"})
        }
        sections.forEach((section => {
            if(parsedState.sections[section.section]) {
                const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
        }));


        if(parsedState.sections && parsedState.sections['cart-drawer']) {
            const elementToReplace =
                document.getElementById('CartDrawer').querySelector('.drawer__inner') || document.getElementById('CartDrawer');
            if(elementToReplace) {
                elementToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '.drawer__inner');
            }
        }
        changeQtyMiniCart();
    }).finally(async () => {
        renderDataGift();
        renderETShipping();
        showPriceSale();
        await renderKlarnaservices()
    });
}
function convertPointToMoney(point) {
    const cents = parseFloat(point * parseFloat(yotpoMoneyPerPoints));
    return parseFloat(cents).toFixed(2).replace('.',',');
}